<div *ngIf="!showContactPage && !isShowHangOnLoading">
  <div class="bl-text-align--center">
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
      <path
        d="M40.5 8H8.5C6.8457 8 5.5 9.34571 5.5 11V35C5.5 35.5522 5.9473 36 6.5 36H42.5C43.0527 36 43.5 35.5522 43.5 35V11C43.5 9.34571 42.1543 8 40.5 8Z"
        fill="#444444"
      />
      <path
        d="M1.5 32.9998V34.9998C1.5 37.7566 3.7432 39.9998 6.5 39.9998H42.5C45.2568 39.9998 47.5 37.7566 47.5 34.9998V32.9998H1.5Z"
        fill="#A5B0B8"
      />
      <path d="M40.5 11H8.5V30H40.5V11Z" fill="white" />
      <path
        d="M27.5 35.9998H21.5C20.3955 35.9998 19.5 35.1043 19.5 33.9998V32.9998H29.5V33.9998C29.5 35.1043 28.6045 35.9998 27.5 35.9998Z"
        fill="#1C2B36"
      />
      <path
        d="M24.5 13C20.634 13 17.5 16.134 17.5 20C17.5 23.866 20.634 27 24.5 27C28.366 27 31.5 23.866 31.5 20H24.5V13Z"
        fill="#E86C60"
      />
      <path d="M24.5 13V20H31.5C31.5 16.134 28.366 13 24.5 13Z" fill="#EFD358" />
    </svg>
  </div>
  <h2 class="bl-font-size--28 bl-margin-bottom--16 bl-font-weight--900 bl-font-color--black bl-text-align--center">Accounts & Services</h2>
  <p *ngIf="isPageSubmitted && !isAnyShareSelected" class="bl-font-size--16 bl-font-color--error bl-font-weight--800">
    {{ 'accountsAndService/noShareSelected' | dictionary }}
  </p>
  <ng-container *ngIf="getIncludedProducts().shares.length > 0 || getOptionalProducts().shares.length > 0">
    <ecp-oao-included-account
      [includedProductsAndServices]="getIncludedProducts()"
      (enableContinueButton)="enableContinueButton($event)"
      [field]="field"
      [optionalProductsAndServices]="getOptionalProducts()"
      [allProducts]="products"
      [coApplicantProducts]="getCoApplicantIncludedProducts()"
      [allServices]="membershipServices"
      [shareOptions]="shareOptions"
      >
    </ecp-oao-included-account>
  </ng-container>
  <div
    id="additional-shares"
    class="bl-block-module bl-padding--16 bl-padding-md--24"
    *ngIf="groupedProducts && groupedProducts.length > 0"
    [attr.data-automation-id]="'additional-options-services-card'"
  >
    <h2 class="bl-font-size--18 bl-margin-bottom--16 bl-font-weight--900">Additional account options</h2>
    <ng-container *ngFor="let product of groupedProducts">
      <ng-container *ngIf="product.productType == 'checking' || product.productType == 'saving' || product.productType == 'moneymarket'">
        <ecp-oao-checking-and-saving-account
          (enableContinueButton)="enableContinueButton($event)"
          [mainAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [isInitialLoading]="isInitialLoading"
        >
        </ecp-oao-checking-and-saving-account>
      </ng-container>
      <ng-container *ngIf="product.productType == 'retirement'">
        <ecp-oao-retirement-account
          (enableContinueButton)="enableContinueButton($event)"
          [retirementAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [isInitialLoading]="isInitialLoading"
        >
        </ecp-oao-retirement-account>
      </ng-container>
      <ng-container *ngIf="product.productType == 'other'">
        <ecp-oao-other-account
          (enableContinueButton)="enableContinueButton($event)"
          [mainAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [isInitialLoading]="isInitialLoading"
        >
        </ecp-oao-other-account>
      </ng-container>
      <ng-container *ngIf="product.productType == 'sharecertificates' || product.productType == 'retiresharecertificates'">
        <ecp-oao-share-certificates-account
          (enableContinueButton)="enableContinueButton($event)"
          [field]="field"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [mainAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [isInitialLoading]="isInitialLoading"
          [shareOptions]="shareOptions"
        >
        </ecp-oao-share-certificates-account>
      </ng-container>
    </ng-container>
    <p
      class="bl-margin-top--16 bl-text-align--center bl-font-color--primary bl-font-size--16 bl-font-weight--800 bl-cursor--pointer"
      *ngIf="showmore && !showFullList"
      (click)="showAllProduct()"
    >
      {{ showmore }}
    </p>
  </div>
  <div
    class="bl-block-module bl-padding--16 bl-padding-md--24 bl-margin-top--24"
    *ngIf="groupedServices && groupedServices.length > 0"
    [attr.data-automation-id]="'additional-addon-services-card'"
  >
    <h2 class="bl-font-size--18 bl-margin-bottom--16 bl-font-weight--900">Additional add-on services</h2>
    <ng-container *ngFor="let service of groupedServices">
      <ecp-oao-other-account-member-service
        [mainService]="getServicesByType(service.productType)"
        [allServices]="membershipServices"
        [coApplicantServices]="getCoApplicantMembershipServiceByType(service.productType)"
        [isInitialLoading]="isInitialLoading"
      >
      </ecp-oao-other-account-member-service>
    </ng-container>
  </div>
</div>
<ecp-lender-contact-blocks *ngIf="showContactPage && !isShowHangOnLoading" [lenderData]="lenderConfig"> </ecp-lender-contact-blocks>

<ng-container *ngIf="dynamicPageHeader()"></ng-container>

<ng-container *ngIf="isShowHangOnLoading && isMidAppDecisionEnabled">
  <div class="bl-block-module bl-padding--48 bl-margin-bottom--24">
    <div class="bl-text-align--center bl-margin-bottom--16">
      <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40.2103" r="40" fill="#FFEBDE" />
        <path
          d="M52.3874 59.766C52.421 59.1796 52.4445 58.5883 52.4445 57.9882C52.4445 50.0855 49.4554 43.2945 45.1623 40.2104C49.4554 37.1263 52.4445 30.3353 52.4445 22.4326C52.4445 21.8325 52.421 21.2412 52.3874 20.6548H27.6126C27.579 21.2412 27.5556 21.8325 27.5556 22.4326C27.5556 30.3353 30.5446 37.1263 34.8377 40.2104C30.5446 43.2945 27.5556 50.0855 27.5556 57.9882C27.5556 58.5883 27.579 59.1796 27.6126 59.766H52.3874Z"
          fill="#BADEFC"
        />
        <path
          d="M56 19.7659H24C23.5087 19.7659 23.1111 20.1635 23.1111 20.6548V22.4326C23.1111 22.9239 23.5087 23.3215 24 23.3215H56C56.4913 23.3215 56.8889 22.9239 56.8889 22.4326V20.6548C56.8889 20.1635 56.4913 19.7659 56 19.7659Z"
          fill="#A67C52"
        />
        <path
          d="M56 57.0992H24C23.5087 57.0992 23.1111 57.4968 23.1111 57.9881V59.7659C23.1111 60.2572 23.5087 60.6548 24 60.6548H56C56.4913 60.6548 56.8889 60.2572 56.8889 59.7659V57.9881C56.8889 57.4968 56.4913 57.0992 56 57.0992Z"
          fill="#A67C52"
        />
        <path
          d="M33.9954 33.9882C34.8289 35.3838 35.8117 36.5316 36.9124 37.3224L40.0001 39.5411L43.0878 37.3224C44.1885 36.5316 45.1713 35.3838 46.0048 33.9882H33.9954Z"
          fill="#EA9860"
        />
        <path
          d="M31.1111 55.3215H48.8889C48 51.7659 42.6111 45.5437 40 45.5437C37.2778 45.5437 31.9444 51.8215 31.1111 55.3215Z"
          fill="#EA9860"
        />
      </svg>
    </div>
    <div class="bl-display--flex bl-text-align--center bl-margin-bottom--16 bl-padding-top--16">
      <p class="bl-margin--0 bl-padding-left--8 bl-font-weight--900 bl-font-size--28 bl-font-color--black">
        {{ 'oaoAccountandService/title' | dictionary }}
      </p>
    </div>
    <div class="bl-text-align--center bl-margin-bottom--32">
      <p class="bl-margin--0 bl-padding-left--8 bl-font-weight--400 bl-font-size--14 bl-font-color--steel">
        {{ 'oaoAccountandService/subTitle' | dictionary }}
      </p>
    </div>
    <div class="bl-display--flex bl-margin-bottom--16 bl-padding-top--16 bl-width--100 bl-row">
      <div class="bl-font-weight--400 bl-font-size--16 bl-text-align--left bl-col-md-6">
        {{ 'oaoAccountandService/pTag1' | dictionary }}
      </div>
      <div class="bl-font-weight--800 bl-col-md-4">
        <div class="progress bl-margin-top--8">
          <div class="progress-bar bl-width--100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <div class="bl-col-md-2">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
              d="M5.818 13.665C5.632 13.665 5.446 13.5936 5.304 13.4516L0.213334 8.36096C0.0769241 8.22455 0.000289915 8.03954 0.000289917 7.84663C0.000289919 7.65372 0.0769241 7.46871 0.213334 7.3323C0.349743 7.19589 0.534755 7.11925 0.727667 7.11925C0.92058 7.11925 1.10559 7.19589 1.242 7.3323L5.81867 11.909L14.7587 2.96896C14.8951 2.83255 15.0801 2.75592 15.273 2.75592C15.4659 2.75592 15.6509 2.83255 15.7873 2.96896C15.9237 3.10537 16.0004 3.29039 16.0004 3.4833C16.0004 3.67621 15.9237 3.86122 15.7873 3.99763L6.33267 13.4516C6.26513 13.5193 6.18491 13.573 6.09659 13.6096C6.00828 13.6462 5.9136 13.665 5.818 13.665Z"
              fill="#2196F3"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white" transform="translate(0 0.210327)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div class="bl-display--flex bl-margin-bottom--16 bl-padding-top--16 bl-width--100 bl-row">
      <div class="bl-font-weight--400 bl-font-size--16 bl-text-align--left bl-col-md-6">
        {{ 'oaoAccountandService/pTag2' | dictionary }}
      </div>
      <div class="bl-font-weight--800 bl-col-md-4">
        <!-- <svg width="250" height="9" viewBox="0 0 250 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.210327" width="250" height="8" rx="4" fill="#2196F3" />
        </svg> -->
        <div class="progress bl-margin-top--8">
          <div class="bl-width--100 progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <div class="bl-col-md-2">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
              d="M5.818 13.665C5.632 13.665 5.446 13.5936 5.304 13.4516L0.213334 8.36096C0.0769241 8.22455 0.000289915 8.03954 0.000289917 7.84663C0.000289919 7.65372 0.0769241 7.46871 0.213334 7.3323C0.349743 7.19589 0.534755 7.11925 0.727667 7.11925C0.92058 7.11925 1.10559 7.19589 1.242 7.3323L5.81867 11.909L14.7587 2.96896C14.8951 2.83255 15.0801 2.75592 15.273 2.75592C15.4659 2.75592 15.6509 2.83255 15.7873 2.96896C15.9237 3.10537 16.0004 3.29039 16.0004 3.4833C16.0004 3.67621 15.9237 3.86122 15.7873 3.99763L6.33267 13.4516C6.26513 13.5193 6.18491 13.573 6.09659 13.6096C6.00828 13.6462 5.9136 13.665 5.818 13.665Z"
              fill="#2196F3"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white" transform="translate(0 0.210327)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <div class="bl-display--flex bl-margin-bottom--16 bl-padding-top--16 bl-width--100 bl-row">
      <div class="bl-font-weight--400 bl-font-size--16 bl-text-align--left bl-col-md-6">
        {{ 'oaoAccountandService/pTag3' | dictionary }}
      </div>
      <div class="bl-font-weight--800 bl-col-md-4">
        <!-- <svg width="250" height="9" viewBox="0 0 250 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.210327" width="250" height="8" rx="4" fill="#2196F3" />
      </svg> -->
        <div class="progress bl-margin-top--8">
          <div
            class="progress-bar"
            role="progressbar"
            [ngStyle]="{ width: progress + '%' }"
            [attr.aria-valuenow]="progress"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <div class="bl-col-md-2" *ngIf="!showTickMark">
        <!-- Convert this to a inline svg-->
        <img src="/assets/images/app-loader-blue.svg" class="circle-account-bar" alt="" aria-hidden="true" />
      </div>
      <div class="bl-col-md-2" *ngIf="showTickMark">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
              d="M5.818 13.665C5.632 13.665 5.446 13.5936 5.304 13.4516L0.213334 8.36096C0.0769241 8.22455 0.000289915 8.03954 0.000289917 7.84663C0.000289919 7.65372 0.0769241 7.46871 0.213334 7.3323C0.349743 7.19589 0.534755 7.11925 0.727667 7.11925C0.92058 7.11925 1.10559 7.19589 1.242 7.3323L5.81867 11.909L14.7587 2.96896C14.8951 2.83255 15.0801 2.75592 15.273 2.75592C15.4659 2.75592 15.6509 2.83255 15.7873 2.96896C15.9237 3.10537 16.0004 3.29039 16.0004 3.4833C16.0004 3.67621 15.9237 3.86122 15.7873 3.99763L6.33267 13.4516C6.26513 13.5193 6.18491 13.573 6.09659 13.6096C6.00828 13.6462 5.9136 13.665 5.818 13.665Z"
              fill="#2196F3"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white" transform="translate(0 0.210327)" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</ng-container>
<ea-orbit-loader [loading]="isShowHangOnLoading && !isMidAppDecisionEnabled"></ea-orbit-loader>
